import React, { Component } from 'react';
import { ApiClient } from "../../libs/apiClient";
import { SERVICE_RESPONSE } from '../../libs/utils/Const';
import { LeyendasFiscales, Mercancias } from '../NewOrder';
import $ from 'jquery';
let apiClient = ApiClient.getInstance();

class ComercioExterior extends Component {
    constructor(props) {
        super(props);
        this.state = {
            states: [],
            municipios: [],
            localidades: [],
            colonias: [],
            isSearchCodigoPostal: false,
            states_Receptor: [],
            municipios_Receptor: [],
            localidades_Receptor: [],
            colonias_Receptor: [],
            isSearchCodigoPostal_Receptor: false,
            showAreYouAgreeModal_Comercio: false,
        };
    }

    //#region LEYENDAS FISCALES
    Add_NewLeyendasFiscales = async (event, index) => {
        const { newOrderModel, showAlert } = this.props;

        let InstanceModel = new LeyendasFiscales();
        if (newOrderModel.LeyendasFiscales.length === 0) {
            newOrderModel.LeyendasFiscales.push(InstanceModel);
        } else {
            let auxLines = newOrderModel.LeyendasFiscales.slice();
            let sendContinue = false;

            for (let index = 0; index < newOrderModel.LeyendasFiscales.length; index++) {
                const element = newOrderModel.LeyendasFiscales[index];

                if (!element.textoLeyenda) {
                    sendContinue = true;
                }
            }

            if (sendContinue) {
                showAlert({ type: "warning", message: `Es necesario llenar el texto de la leyenda para poder agregar una nueva Leyenda Fiscal.` });
                return;
            }
            auxLines.push(InstanceModel)
            newOrderModel.LeyendasFiscales = auxLines;
        }

        this.refreshModel(newOrderModel);
    };

    Delete_LeyendasFiscales = async (index) => {
        const { newOrderModel } = this.props;
        let auxLines = newOrderModel.LeyendasFiscales.slice();
        auxLines.splice(index, 1); // 1 es la cantidad de elemento a eliminar
        newOrderModel.LeyendasFiscales = auxLines;
        this.refreshModel(newOrderModel);
    };

    Change_isLeyendaFiscal = async (event, index) => {
        const { newOrderModel } = this.props;
        newOrderModel.isLeyendaFiscal = !newOrderModel.isLeyendaFiscal;
        newOrderModel.SelectLeyendas = true;
        this.refreshModel(newOrderModel);
    };

    Change_disposicionFiscal = (event, index) => {
        const { newOrderModel } = this.props;
        newOrderModel.LeyendasFiscales[index].disposicionFiscal = event.nativeEvent.target.value;
        newOrderModel.SelectLeyendas = true;
        this.refreshModel(newOrderModel);
    };

    Change_norma = (event, index) => {
        const { newOrderModel } = this.props;
        newOrderModel.LeyendasFiscales[index].norma = event.nativeEvent.target.value;
        newOrderModel.SelectLeyendas = true;
        this.refreshModel(newOrderModel);
    };

    Change_textoLeyenda = (event, index) => {
        const { newOrderModel } = this.props;
        newOrderModel.LeyendasFiscales[index].textoLeyenda = event.nativeEvent.target.value;
        newOrderModel.SelectLeyendas = true;
        this.refreshModel(newOrderModel);
    };
    //#endregion

    //#region COMERCIO EXTERIOR
    Change_isComercioExterior = async (event, index) => {
        const { action, newOrderModel } = this.props;
        newOrderModel.isComercioExterior = newOrderModel.isComercioExterior === "Y" ? 'N' : 'Y';
        const timbraStatus = newOrderModel.U_UDF_UUID && newOrderModel.IsCancelCFDI === "N";

        if (newOrderModel.isComercioExterior === "Y") {
            if (action === 1) {
                newOrderModel.ComercioExterior.Mercancias = [];
                for (let index = 0; index < newOrderModel.Items.length; index++) {
                    const item = newOrderModel.Items[index];

                    let instanceMercancia = new Mercancias();
                    instanceMercancia.NoIdentificacion = item.ItemCode || '';

                    newOrderModel.ComercioExterior.Mercancias.push(instanceMercancia);
                }
            }
            // Agregar mercancias al editar documento sin ser timbrado
            if (action === 2 && !timbraStatus) {
                newOrderModel.ComercioExterior.Mercancias = [];
                for (let index = 0; index < newOrderModel.Items.length; index++) {
                    const item = newOrderModel.Items[index];

                    let instanceMercancia = new Mercancias();
                    instanceMercancia.NoIdentificacion = item.ItemCode || '';

                    newOrderModel.ComercioExterior.Mercancias.push(instanceMercancia);
                }
            }
        }
        this.refreshModel(newOrderModel);
    };

    Change_CertificadoOrigen = (event, index) => {
        const { newOrderModel } = this.props;
        newOrderModel.ComercioExterior.CertificadoOrigen = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    Change_NumCertificadoOrigen = (event, index) => {
        const { newOrderModel } = this.props;
        newOrderModel.ComercioExterior.NumCertificadoOrigen = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    Change_INCOTERM = (event, index) => {
        const { newOrderModel } = this.props;
        newOrderModel.ComercioExterior.INCOTERM = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    Change_Observaciones = (event, index) => {
        const { newOrderModel } = this.props;
        newOrderModel.ComercioExterior.Observaciones = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    Change_NumRegIdTrib = (event, index) => {
        const { newOrderModel } = this.props;
        newOrderModel.ComercioExterior.Receptor_NumRegIdTrib = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    GetStates = async (pais) => {
        const { enableSpinner } = this.props;

        enableSpinner(true);
        let stateSATResponse = await apiClient.getStateSAT(pais);
        enableSpinner(false);

        this.setState({ states: stateSATResponse.data });
    };

    GetStates_Receptor = async (pais) => {
        const { enableSpinner } = this.props;

        enableSpinner(true);
        let stateSATResponse = await apiClient.getStateSAT(pais);
        enableSpinner(false);

        this.setState({ states_Receptor: stateSATResponse.data });
    };

    FilterArrayDoubleValues = (propertyCompare, array) => {
        const uniqueIds = {};
        const resultado = [];
        array.forEach(obj => {
            if (!uniqueIds[obj[propertyCompare]]) {
                uniqueIds[obj[propertyCompare]] = true;
                resultado.push(obj);
            }
        });
        return resultado;
    }

    getCodigoPostalSAT = async (codigoPostal) => {
        const { showAlert, enableSpinner, newOrderModel } = this.props;
        if (!codigoPostal) {
            showAlert({ type: 'info', message: 'No hay un Codigo postal' });
            return;
        }
        this.setState({
            isSearchCodigoPostal: true,
        });
        enableSpinner(true);
        let codigoPostalSATResponse = await apiClient.getCodigoPostalSAT(codigoPostal);
        enableSpinner(false);

        if (codigoPostalSATResponse.status === 1) {
            if (codigoPostalSATResponse.data.length === 0) { return showAlert({ type: 'info', message: 'No hay Información por mostrar' }); }

            newOrderModel.ComercioExterior.Emisor_Pais = codigoPostalSATResponse.data.direccion[0] ? codigoPostalSATResponse.data.direccion[0].c_Pais : '';
            if (newOrderModel.ComercioExterior.Emisor_Pais === 'MEX') {
                await this.GetStates(newOrderModel.ComercioExterior.Emisor_Pais);
            }
            newOrderModel.ComercioExterior.Emisor_Estado = codigoPostalSATResponse.data.direccion[0] ? codigoPostalSATResponse.data.direccion[0].c_Estado : '';
            newOrderModel.ComercioExterior.Emisor_Municipio = codigoPostalSATResponse.data.direccion[0] ? codigoPostalSATResponse.data.direccion[0].c_Municipio : '';

            this.refreshModel(newOrderModel);
            this.setState({
                localidades: codigoPostalSATResponse.data.localidades,
                colonias: codigoPostalSATResponse.data.colonias,
                municipios: codigoPostalSATResponse.data.municipios,
            });
        }
    }

    getCodigoPostalSAT_Receptor = async (codigoPostal, type) => {
        const { showAlert, enableSpinner, newOrderModel } = this.props;
        if (!codigoPostal) {
            showAlert({ type: 'info', message: 'No hay un Codigo postal' });
            return;
        }
        this.setState({
            isSearchCodigoPostal_Receptor: true,
        });
        enableSpinner(true);
        let codigoPostalSATResponse = await apiClient.getCodigoPostalSAT(codigoPostal);
        enableSpinner(false);

        if (codigoPostalSATResponse.status === 1) {
            if (codigoPostalSATResponse.data.length === 0) { return showAlert({ type: 'info', message: 'No hay Información por mostrar' }); }

            newOrderModel.ComercioExterior.Receptor_Pais = codigoPostalSATResponse.data.direccion[0] ? codigoPostalSATResponse.data.direccion[0].c_Pais : '';
            if (newOrderModel.ComercioExterior.Receptor_Pais === 'MEX') {
                await this.GetStates_Receptor(newOrderModel.ComercioExterior.Receptor_Pais);
            }
            newOrderModel.ComercioExterior.Receptor_Estado = codigoPostalSATResponse.data.direccion[0] ? codigoPostalSATResponse.data.direccion[0].c_Estado : '';
            newOrderModel.ComercioExterior.Receptor_Municipio = codigoPostalSATResponse.data.direccion[0] ? codigoPostalSATResponse.data.direccion[0].c_Municipio : '';

            this.refreshModel(newOrderModel);
            this.setState({
                localidades_Receptor: codigoPostalSATResponse.data.localidades,
                colonias_Receptor: codigoPostalSATResponse.data.colonias,
                municipios_Receptor: codigoPostalSATResponse.data.municipios,
            });
        }
    }

    changeFieldModel_Emisor = async (newOrderModel, key, value) => {
        const { showAlert, enableSpinner } = this.props;

        if (key === 'Emisor_CodigoPostal') {
            if (isNaN(value)) {
                showAlert({ type: 'warning', message: 'El código postal solo permite números' });
                return;
            }
        }
        if (key === 'Emisor_NumeroExterior') {
            if (isNaN(value)) {
                showAlert({ type: 'warning', message: 'El número exterior solo permite números' });
                return;
            }
        }

        newOrderModel.ComercioExterior[key] = value;

        if (key === 'Emisor_CodigoPostal') {
            // newOrderModel.ComercioExterior.Emisor_Colonia = '';
            // newOrderModel.ComercioExterior.Emisor_Localidad = '';
            // newOrderModel.ComercioExterior.Emisor_Municipio = '';
            // newOrderModel.ComercioExterior.Emisor_Estado = '';
            // newOrderModel.ComercioExterior.Emisor_Pais = '';
        } else if (key === 'Emisor_Pais') {
            // newOrderModel.ComercioExterior.Emisor_Colonia = '';
            // newOrderModel.ComercioExterior.Emisor_Localidad = '';
            // newOrderModel.ComercioExterior.Emisor_Municipio = '';
            // newOrderModel.ComercioExterior.Emisor_Estado = '';            
        } else if (key === 'Emisor_Estado') {
            newOrderModel.ComercioExterior.Emisor_Colonia = '';
            newOrderModel.ComercioExterior.Emisor_Localidad = '';
            newOrderModel.ComercioExterior.Emisor_Municipio = '';
        } else if (key === 'Emisor_Municipio') {
            newOrderModel.ComercioExterior.Emisor_Colonia = '';
            newOrderModel.ComercioExterior.Emisor_Localidad = '';
        } else if (key === 'Emisor_Colonia') {
            const { colonias } = this.state;
            const colonia = colonias ? colonias.find(({ c_Colonia }) => c_Colonia === newOrderModel.ComercioExterior.Emisor_Colonia) : undefined;

            if (colonia) { newOrderModel.ComercioExterior.Emisor_CodigoPostal = colonia.c_CodigoPostal || newOrderModel.ComercioExterior.Emisor_CodigoPostal; }
        }

        this.refreshModel(newOrderModel);

        if (key === 'Emisor_Pais') {
            await this.GetStates(newOrderModel.ComercioExterior.Emisor_Pais);
        } else if (key === 'Emisor_Estado') {
            enableSpinner(true);
            const responseApi = await apiClient.getMunicipioSAT(value);
            const districtData = await apiClient.getLocalidadSAT(value || '');
            enableSpinner(false);
            if (responseApi.status) {
                await this.setState({
                    municipios: responseApi.data || [],
                    localidades: districtData.data || []
                })
            }
        } else if (key === 'Emisor_Municipio') {
            this.setState({ colonias: [] });
            enableSpinner(true);
            const responseApi = await apiClient.getAddressDetailSAT({ action: 'getTowns', state: newOrderModel.ComercioExterior.Emisor_Estado, municipality: newOrderModel.ComercioExterior.Emisor_Municipio, district: newOrderModel.ComercioExterior.Emisor_Localidad });
            if (responseApi.status === 1) {
                this.setState({ colonias: await this.FilterArrayDoubleValues('Colonias', responseApi.data) || [] });
            }
            enableSpinner(false);
        }
    };

    changeFieldModel_Receptor = async (newOrderModel, key, value) => {
        const { showAlert, enableSpinner } = this.props;

        if (key === 'Receptor_CodigoPostal') {
            if (isNaN(value)) {
                showAlert({ type: 'warning', message: 'El código postal solo permite números' });
                return;
            }
        }
        if (key === 'Receptor_NumeroExterior') {
            if (isNaN(value)) {
                showAlert({ type: 'warning', message: 'El número exterior solo permite números' });
                return;
            }
        }

        newOrderModel.ComercioExterior[key] = value;

        if (key === 'Receptor_CodigoPostal' && newOrderModel.ComercioExterior.Receptor_Pais === 'MEX') {
            // newOrderModel.ComercioExterior.Receptor_Colonia = '';
            // newOrderModel.ComercioExterior.Receptor_Localidad = '';
            // newOrderModel.ComercioExterior.Receptor_Municipio = '';
            // newOrderModel.ComercioExterior.Receptor_Estado = '';
            // newOrderModel.ComercioExterior.Receptor_Pais = '';
        } else if (key === 'Receptor_Pais') {
            // newOrderModel.ComercioExterior.Receptor_Colonia = '';
            // newOrderModel.ComercioExterior.Receptor_Localidad = '';
            // newOrderModel.ComercioExterior.Receptor_Municipio = '';
            // newOrderModel.ComercioExterior.Receptor_Estado = '';            
        } else if (key === 'Receptor_Estado') {
            newOrderModel.ComercioExterior.Receptor_Colonia = '';
            newOrderModel.ComercioExterior.Receptor_Localidad = '';
            newOrderModel.ComercioExterior.Receptor_Municipio = '';
        } else if (key === 'Receptor_Municipio') {
            newOrderModel.ComercioExterior.Receptor_Colonia = '';
            newOrderModel.ComercioExterior.Receptor_Localidad = '';
        } else if (key === 'Receptor_Colonia') {
            const { colonias_Receptor } = this.state;
            const colonia = colonias_Receptor ? colonias_Receptor.find(({ c_Colonia }) => c_Colonia === newOrderModel.ComercioExterior.Receptor_Colonia) : undefined;

            if (colonia) { newOrderModel.ComercioExterior.Receptor_CodigoPostal = colonia.c_CodigoPostal || newOrderModel.ComercioExterior.Receptor_CodigoPostal; }
        }

        this.refreshModel(newOrderModel);

        if (key === 'Receptor_Pais') {
            await this.GetStates_Receptor(newOrderModel.ComercioExterior.Receptor_Pais);
        } else if (key === 'Receptor_Estado') {
            enableSpinner(true);
            const responseApi = await apiClient.getMunicipioSAT(value);
            const districtData = await apiClient.getLocalidadSAT(value || '');
            enableSpinner(false);
            if (responseApi.status) {
                await this.setState({
                    municipios_Receptor: responseApi.data || [],
                    localidades_Receptor: districtData.data || []
                })
            }
        } else if (key === 'Receptor_Municipio') {
            this.setState({ colonias_Receptor: [] });
            enableSpinner(true);
            const responseApi = await apiClient.getAddressDetailSAT({ action: 'getTowns', state: newOrderModel.ComercioExterior.Receptor_Estado, municipality: newOrderModel.ComercioExterior.Receptor_Municipio, district: newOrderModel.ComercioExterior.Receptor_Localidad });
            if (responseApi.status === 1) {
                this.setState({ colonias_Receptor: await this.FilterArrayDoubleValues('Colonias', responseApi.data) || [] });
            }
            enableSpinner(false);
        }
    };

    Change_UnidadAduana = (event, index) => {
        const { newOrderModel } = this.props;
        newOrderModel.ComercioExterior.Mercancias[index].UnidadAduana = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };

    Change_Marca = (event, index) => {
        const { newOrderModel } = this.props;
        newOrderModel.ComercioExterior.Mercancias[index].Marca = event.nativeEvent.target.value;
        this.refreshModel(newOrderModel);
    };
    //#endregion

    refreshModel = (newOrderModel) => {
        const { refreshModel } = this.props;
        console.log('D5>> newOrderModel', newOrderModel);
        refreshModel(JSON.parse(JSON.stringify(newOrderModel)));
    };

    render() {
        const { newOrderModel, view, action, editMode } = this.props;
        const { isSearchCodigoPostal, isSearchCodigoPostal_Receptor, states, states_Receptor, municipios, municipios_Receptor, localidades, localidades_Receptor, colonias, colonias_Receptor } = this.state;
        let ComercioExterior = newOrderModel.ComercioExterior ? newOrderModel.ComercioExterior : {};
        if (view === 'invoice') {
            if (ComercioExterior.Emisor_CodigoPostal !== "" && ComercioExterior.Emisor_CodigoPostal !== undefined && ComercioExterior.Emisor_Pais === 'MEX') {
                if (!isSearchCodigoPostal && action == 2) {
                    this.getCodigoPostalSAT(ComercioExterior.Emisor_CodigoPostal);
                }
            }

            if (ComercioExterior.Receptor_CodigoPostal !== "" && ComercioExterior.Receptor_CodigoPostal !== undefined && ComercioExterior.Receptor_Pais === 'MEX') {
                if (!isSearchCodigoPostal_Receptor && action == 2) {
                    this.getCodigoPostalSAT_Receptor(ComercioExterior.Receptor_CodigoPostal);
                }
            }
        }

        return (
            <div className="tab-pane fade border border-top-0 rounded-bottom p-3" id="dataComplemento">
                <nav>
                    <div className="nav nav-tabs">
                        <a className="nav-item nav-link font-weight-bold text-secondary active" id="navComercioExterior" href="#ComercioExterior" data-toggle="tab">
                            Comercio Exterior
                        </a>
                        {/*<a className="nav-item nav-link font-weight-bold text-secondary" id="navLeyendasFiscales" href="#LeyendasFiscales" data-toggle="tab">
                            Leyendas Fiscales
                        </a>*/}
                    </div>
                </nav>
                <div class="tab-content">
                    <div className="tab-pane fade border border-top-0 rounded-bottom p-3 active show" id="ComercioExterior">
                        <div className="row">
                            <div className="col-12">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">
                                            <input
                                                id="cbComercioExterior"
                                                type="checkbox"
                                                checked={newOrderModel.isComercioExterior === "Y"}
                                                disabled={action === 2 && !editMode ? true : false}
                                                onChange={(event) => this.Change_isComercioExterior(event)} />
                                        </div>
                                    </div>
                                    <label className="form-control" htmlFor="cbComercioExterior"> Comercio Exterior </label>
                                </div>
                            </div>

                            {/* Primer columna */}
                            <div className="col-12 col-md-6">
                                {/* Certificado Origen */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Certificado Origen</span>
                                            <span className="d-inline d-xl-none">Cert. Origen</span>
                                        </span>
                                    </div>
                                    <select
                                        type=" text"
                                        className=" form-control"
                                        id="txtNo"
                                        disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                        value={ComercioExterior.CertificadoOrigen ? ComercioExterior.CertificadoOrigen : ''}
                                        onChange={event => this.Change_CertificadoOrigen(event)}>
                                        <option value=''>Selecciona</option>
                                        <option value='0'>No Funge como certificado de origen</option>
                                        <option value='1'>Funge como certificado de origen</option>
                                    </select>
                                </div>
                                {/* INCOTERM */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">INCOTERM</span>
                                    </div>
                                    <select
                                        type=" text"
                                        className=" form-control"
                                        id="txtNo"
                                        disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                        value={ComercioExterior.INCOTERM ? ComercioExterior.INCOTERM : ''}
                                        onChange={event => this.Change_INCOTERM(event)}>
                                        <option value=''>Selecciona</option>
                                        <option value='CFR'>CFR-COSTE Y FLETE (PUERTO DE DESTINO CONVENIDO).</option>
                                        <option value='CIF'>CIF-COSTE, SEGURO Y FLETE (PUERTO DE DESTINO CONVENIDO).</option>
                                        <option value='CPT'>CPT-TRANSPORTE PAGADO HASTA (EL LUGAR DE DESTINO CONVENIDO).</option>
                                        <option value='CIP'>CIP-TRANSPORTE Y SEGURO PAGADOS HASTA (LUGAR DE DESTINO CONVENIDO).</option>
                                        <option value='DAP'>DAP-ENTREGADA EN LUGAR.</option>
                                        <option value='DDP'>DDP-ENTREGADA DERECHOS PAGADOS (LUGAR DE DESTINO CONVENIDO).</option>
                                        <option value='DPU'>DPU-ENTREGADA Y DESCARGADA EN LUGAR ACORDADO.</option>
                                        <option value='EXW'>EXW-EN FABRICA (LUGAR CONVENIDO).</option>
                                        <option value='FCA'>FCA-FRANCO TRANSPORTISTA (LUGAR DESIGNADO).</option>
                                        <option value='FAS'>FAS-FRANCO AL COSTADO DEL BUQUE (PUERTO DE CARGA CONVENIDO).</option>
                                        <option value='FOB'>FOB-FRANCO A BORDO (PUERTO DE CARGA CONVENIDO).</option>
                                    </select>
                                </div>
                            </div>

                            {/* Segunda columna */}
                            <div className="col-12 col-md-6">
                                {/* N° de Certificado Origen */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">N° de Certificado Origen</span>
                                            <span className="d-inline d-xl-none">N° Cert. Origen</span>
                                        </span>
                                    </div>
                                    <input
                                        type=" text"
                                        className=" form-control"
                                        id="txtNo"
                                        minLength={6}
                                        maxLength={40}
                                        disabled={action === 2 && !editMode ? true : (ComercioExterior.CertificadoOrigen === '0' || ComercioExterior.CertificadoOrigen === '') ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                        value={ComercioExterior.NumCertificadoOrigen ? ComercioExterior.NumCertificadoOrigen : ''}
                                        onChange={event => this.Change_NumCertificadoOrigen(event)}
                                    />
                                </div>
                                {/* Observaciones */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Observaciones</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="txtPartner"
                                        autocomplete="off"
                                        minLength={1}
                                        maxLength={300}
                                        disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                        onChange={this.Change_Observaciones}
                                        value={ComercioExterior.Observaciones ? ComercioExterior.Observaciones : ''} />
                                </div>
                            </div>
                        </div>
                        
                        <nav>
                            <div className="nav nav-tabs">
                                <a className="nav-item nav-link font-weight-bold text-secondary active" id="navComExtEmisor" href="#ComExtEmisor" data-toggle="tab">
                                    Emisor
                                </a>
                                <a className="nav-item nav-link font-weight-bold text-secondary" id="navComExtReceptor" href="#ComExtReceptor" data-toggle="tab">
                                    Receptor
                                </a>
                            </div>
                        </nav>
                        <div class="tab-content">
                            {/* DIRECCIONES DE EMISOR */}
                            <div className="container tab-pane fade border border-top-0 rounded-bottom p-3 show active" id="ComExtEmisor">
                                <div className="row">
                                    {/* Primer columna */}
                                    <div className="col-12 col-md-6">
                                        {/* PAÍS */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text font-weight-bold" id="basic-addon1">País</span>
                                            </div>
                                            <select id="selPais" class="form-control" value={ComercioExterior.Emisor_Pais ? ComercioExterior.Emisor_Pais : ""}
                                                onChange={(event) => this.changeFieldModel_Emisor(newOrderModel, "Emisor_Pais", event.target.value)}
                                                disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                            >
                                                <option value=''>Seleccione una opción</option>
                                                <option value='MEX'>México</option>
                                                <option value='USA'>Estados Unidos (los)</option>
                                            </select>
                                        </div>
                                        {/* MUNICIPIO */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text font-weight-bold" id="basic-addon1">Municipio</span>
                                            </div>
                                            {ComercioExterior && ComercioExterior.Emisor_Pais !== '' && ComercioExterior.Emisor_Pais !== 'MEX' ?
                                                <input type="text" className="form-control"
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                    value={ComercioExterior.Emisor_Municipio ? ComercioExterior.Emisor_Municipio : ""}
                                                    onChange={(event) => this.changeFieldModel_Emisor(newOrderModel, "Emisor_Municipio", event.target.value)}
                                                    id="txtMunicipio" />
                                                :
                                                <select id="selMunicipio" class="form-control" value={ComercioExterior.Emisor_Municipio ? ComercioExterior.Emisor_Municipio : ""}
                                                    onChange={(event) => this.changeFieldModel_Emisor(newOrderModel, "Emisor_Municipio", event.target.value)}
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : !ComercioExterior.Emisor_Estado}
                                                >
                                                    <option value=''>Seleccione una opción</option>
                                                    {!!municipios && municipios.map((dato => {
                                                        return (
                                                            <option value={dato.c_Municipio}>{dato.Nombre || dato.Municipio}</option>
                                                        );
                                                    }))}
                                                </select>
                                            }
                                        </div>
                                        {/* COLONIA */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text font-weight-bold" id="basic-addon1">Colonia</span>
                                            </div>
                                            {ComercioExterior && ComercioExterior.Emisor_Pais !== '' && ComercioExterior.Emisor_Pais !== 'MEX' ?
                                                <input type="text" className="form-control"
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                    value={ComercioExterior.Emisor_Colonia ? ComercioExterior.Emisor_Colonia : ""}
                                                    onChange={(event) => this.changeFieldModel_Emisor(newOrderModel, "Emisor_Colonia", event.target.value)}
                                                    id="txtColonia" />
                                                :
                                                <select id="selColonia" class="form-control" value={ComercioExterior.Emisor_Colonia ? ComercioExterior.Emisor_Colonia : ""}
                                                    onChange={(event) => this.changeFieldModel_Emisor(newOrderModel, "Emisor_Colonia", event.target.value)}
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : !ComercioExterior.Emisor_Municipio}
                                                >
                                                    <option value=''>Seleccione una opción</option>
                                                    {!!colonias && colonias.map((dato => {
                                                        return (
                                                            <option value={dato.c_Colonia}>{dato.Nombre || dato.Colonias}</option>
                                                        );
                                                    }))}
                                                </select>
                                            }
                                        </div>
                                        {/* CALLE */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text font-weight-bold" id="basic-addon1">Calle</span>
                                            </div>
                                            <input type="text" className="form-control"
                                                disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                maxLength={5000}
                                                value={ComercioExterior.Emisor_Calle ? ComercioExterior.Emisor_Calle : ""}
                                                onChange={(event) => this.changeFieldModel_Emisor(newOrderModel, "Emisor_Calle", event.target.value)}
                                                id="txtCalle" />
                                        </div>
                                    </div>

                                    {/* Segunda columna */}
                                    <div className="col-12 col-md-6">
                                        {/* ESTADO */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                                            </div>
                                            {ComercioExterior && ComercioExterior.Emisor_Pais !== '' && ComercioExterior.Emisor_Pais !== 'MEX' ?
                                                <input type="text" className="form-control"
                                                    disabled={((!isSearchCodigoPostal || action === 2) && !editMode) ? true : false}
                                                    value={ComercioExterior.Emisor_Estado ? ComercioExterior.Emisor_Estado : ""}
                                                    onChange={(event) => this.changeFieldModel_Emisor(newOrderModel, "Emisor_Estado", event.target.value)}
                                                    id="txtEstado" />
                                                :
                                                <select
                                                    id="selectState"
                                                    class="form-control"
                                                    value={ComercioExterior.Emisor_Estado ? ComercioExterior.Emisor_Estado : ""}
                                                    onChange={(event) => this.changeFieldModel_Emisor(newOrderModel, "Emisor_Estado", event.target.value)}
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : !ComercioExterior.Emisor_Pais} >
                                                    <option value=''>Seleccione una opción</option>
                                                    {!!states && states.map((dato => {
                                                        return (
                                                            <option value={dato.c_Estado}>{dato.Nombre || dato.Estado}</option>
                                                        );
                                                    }))}
                                                </select>
                                            }
                                        </div>
                                        {/* CIUDAD / LOCALIDAD */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                    <span className="d-none d-xl-inline">Ciudad / Localidad</span>
                                                    <span className="d-inline d-xl-none">Ciu/Local</span>
                                                </span>
                                            </div>
                                            {ComercioExterior && ComercioExterior.Emisor_Pais !== '' && ComercioExterior.Emisor_Pais !== 'MEX' ?
                                                <input type="text" className="form-control"
                                                    disabled={(!(isSearchCodigoPostal || action === 2) && !editMode) ? true : false}
                                                    value={ComercioExterior.Emisor_Localidad ? ComercioExterior.Emisor_Localidad : ""}
                                                    onChange={(event) => this.changeFieldModel_Emisor(newOrderModel, "Emisor_Localidad", event.target.value)}
                                                    id="txtLocalidad" />
                                                :
                                                <select id="selLocalidades" class="form-control" value={ComercioExterior.Emisor_Localidad ? ComercioExterior.Emisor_Localidad : ""}
                                                    onChange={(event) => this.changeFieldModel_Emisor(newOrderModel, "Emisor_Localidad", event.target.value)}
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : !ComercioExterior.Emisor_Municipio}
                                                >
                                                    <option value=''>Seleccione una opción</option>
                                                    {!!localidades && localidades.map((dato => {
                                                        return (
                                                            <option value={dato.c_Localidad}>{dato.Nombre || dato.Localidad}</option>
                                                        );
                                                    }))}
                                                </select>
                                            }
                                        </div>
                                        {/* CÓDIGO POSTAL */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                    <span className="d-none d-xl-inline">Código Postal</span>
                                                    <span className="d-inline d-xl-none">C. Postal</span>
                                                </span>
                                            </div>
                                            <input type="text" className="form-control"
                                                disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                maxLength={5}
                                                onKeyPress={(eve) => {
                                                    if (eve.key === 'Enter') {
                                                        this.getCodigoPostalSAT(ComercioExterior.Emisor_CodigoPostal);
                                                    }
                                                }}
                                                value={ComercioExterior.Emisor_CodigoPostal !== undefined ? ComercioExterior.Emisor_CodigoPostal : ""}
                                                onChange={(event) => this.changeFieldModel_Emisor(newOrderModel, "Emisor_CodigoPostal", event.target.value)}
                                                id="txtCodigoPostal" />
                                            <button type="button" class="input-group-text"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                onClick={() => { this.getCodigoPostalSAT(ComercioExterior.Emisor_CodigoPostal) }}>
                                                <i class="fas fa-search-location fa-lg" />
                                            </button>
                                        </div>
                                        {/* NÚMERO EXTERIOR */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                    <span className="d-none d-xl-inline">Número Exterior</span>
                                                    <span className="d-inline d-xl-none">No. Ext</span>
                                                </span>
                                            </div>
                                            <input type="number" className="form-control"
                                                disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                maxLength={10}
                                                value={ComercioExterior.Emisor_NumeroExterior ? ComercioExterior.Emisor_NumeroExterior : ""}
                                                onChange={(event) => this.changeFieldModel_Emisor(newOrderModel, "Emisor_NumeroExterior", event.target.value)}
                                                id="txtNumExterior" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* DIRECCIONES DE RECEPTOR */}
                            <div className="container tab-pane fade border border-top-0 rounded-bottom p-3" id="ComExtReceptor">
                                <div className="row">
                                    {/* Primer columna */}
                                    <div className="col-12 col-md-6">
                                        {/* NumRegIdTrib */}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                    <span className="d-none d-xl-inline">N° de identificación</span>
                                                    <span className="d-inline d-xl-none">N° Ident.</span>
                                                </span>
                                            </div>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="txtPartner"
                                                autocomplete="off"
                                                minLength={1}
                                                maxLength={20}
                                                disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                onChange={this.Change_NumRegIdTrib}
                                                value={ComercioExterior.Receptor_NumRegIdTrib ? ComercioExterior.Receptor_NumRegIdTrib : ''} />
                                        </div>
                                        {/* PAÍS */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text font-weight-bold" id="basic-addon1">País</span>
                                            </div>
                                            <select id="selPais" class="form-control" value={ComercioExterior.Receptor_Pais ? ComercioExterior.Receptor_Pais : ""}
                                                onChange={(event) => this.changeFieldModel_Receptor(newOrderModel, "Receptor_Pais", event.target.value)}
                                                disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                            >
                                                <option value=''>Seleccione una opción</option>
                                                <option value='MEX'>México</option>
                                                <option value='USA'>Estados Unidos (los)</option>
                                            </select>
                                        </div>
                                        {/* MUNICIPIO */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text font-weight-bold" id="basic-addon1">Municipio</span>
                                            </div>
                                            {ComercioExterior && ComercioExterior.Receptor_Pais !== '' && ComercioExterior.Receptor_Pais !== 'MEX' ?
                                                <input type="text" className="form-control"
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                    value={ComercioExterior.Receptor_Municipio ? ComercioExterior.Receptor_Municipio : ""}
                                                    onChange={(event) => this.changeFieldModel_Receptor(newOrderModel, "Receptor_Municipio", event.target.value)}
                                                    id="txtMunicipio" />
                                                :
                                                <select id="selMunicipio" class="form-control" value={ComercioExterior.Receptor_Municipio ? ComercioExterior.Receptor_Municipio : ""}
                                                    onChange={(event) => this.changeFieldModel_Receptor(newOrderModel, "Receptor_Municipio", event.target.value)}
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : !ComercioExterior.Receptor_Estado}
                                                >
                                                    <option value=''>Seleccione una opción</option>
                                                    {!!municipios_Receptor && municipios_Receptor.map((dato => {
                                                        return (
                                                            <option value={dato.c_Municipio}>{dato.Nombre || dato.Municipio}</option>
                                                        );
                                                    }))}
                                                </select>
                                            }
                                        </div>
                                        {/* COLONIA */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text font-weight-bold" id="basic-addon1">Colonia</span>
                                            </div>
                                            {ComercioExterior && ComercioExterior.Receptor_Pais !== '' && ComercioExterior.Receptor_Pais !== 'MEX' ?
                                                <input type="text" className="form-control"
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                    value={ComercioExterior.Receptor_Colonia ? ComercioExterior.Receptor_Colonia : ""}
                                                    onChange={(event) => this.changeFieldModel_Receptor(newOrderModel, "Receptor_Colonia", event.target.value)}
                                                    id="txtColonia" />
                                                :
                                                <select id="selColonia" class="form-control" value={ComercioExterior.Receptor_Colonia ? ComercioExterior.Receptor_Colonia : ""}
                                                    onChange={(event) => this.changeFieldModel_Receptor(newOrderModel, "Receptor_Colonia", event.target.value)}
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : !ComercioExterior.Receptor_Municipio}
                                                >
                                                    <option value=''>Seleccione una opción</option>
                                                    {!!colonias_Receptor && colonias_Receptor.map((dato => {
                                                        return (
                                                            <option value={dato.c_Colonia}>{dato.Nombre || dato.Colonias}</option>
                                                        );
                                                    }))}
                                                </select>
                                            }
                                        </div>
                                        {/* CALLE */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text font-weight-bold" id="basic-addon1">Calle</span>
                                            </div>
                                            <input type="text" className="form-control"
                                                disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                maxLength={5000}
                                                value={ComercioExterior.Receptor_Calle ? ComercioExterior.Receptor_Calle : ""}
                                                onChange={(event) => this.changeFieldModel_Receptor(newOrderModel, "Receptor_Calle", event.target.value)}
                                                id="txtCalle" />
                                        </div>
                                    </div>

                                    {/* Segunda columna */}
                                    <div className="col-12 col-md-6">
                                        {/* ESTADO */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                                            </div>
                                            {ComercioExterior && ComercioExterior.Receptor_Pais !== '' && ComercioExterior.Receptor_Pais !== 'MEX' ?
                                                <input type="text" className="form-control"
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                    value={ComercioExterior.Receptor_Estado ? ComercioExterior.Receptor_Estado : ""}
                                                    onChange={(event) => this.changeFieldModel_Receptor(newOrderModel, "Receptor_Estado", event.target.value)}
                                                    id="txtEstado" />
                                                :
                                                <select
                                                    id="selectState"
                                                    class="form-control"
                                                    value={ComercioExterior.Receptor_Estado ? ComercioExterior.Receptor_Estado : ""}
                                                    onChange={(event) => this.changeFieldModel_Receptor(newOrderModel, "Receptor_Estado", event.target.value)}
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : !ComercioExterior.Receptor_Pais} >
                                                    <option value=''>Seleccione una opción</option>
                                                    {!!states_Receptor && states_Receptor.map((dato => {
                                                        return (
                                                            <option value={dato.c_Estado}>{dato.Nombre || dato.Estado}</option>
                                                        );
                                                    }))}
                                                </select>
                                            }
                                        </div>
                                        {/* CIUDAD / LOCALIDAD */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                    <span className="d-none d-xl-inline">Ciudad / Localidad</span>
                                                    <span className="d-inline d-xl-none">Ciu/Local</span>
                                                </span>
                                            </div>
                                            {ComercioExterior && ComercioExterior.Receptor_Pais !== '' && ComercioExterior.Receptor_Pais !== 'MEX' ?
                                                <input type="text" className="form-control"
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                    value={ComercioExterior.Receptor_Localidad ? ComercioExterior.Receptor_Localidad : ""}
                                                    onChange={(event) => this.changeFieldModel_Receptor(newOrderModel, "Receptor_Localidad", event.target.value)}
                                                    id="txtLocalidad" />
                                                :
                                                <select id="selLocalidades" class="form-control" value={ComercioExterior.Receptor_Localidad ? ComercioExterior.Receptor_Localidad : ""}
                                                    onChange={(event) => this.changeFieldModel_Receptor(newOrderModel, "Receptor_Localidad", event.target.value)}
                                                    disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : !ComercioExterior.Receptor_Municipio}
                                                >
                                                    <option value=''>Seleccione una opción</option>
                                                    {!!localidades_Receptor && localidades_Receptor.map((dato => {
                                                        return (
                                                            <option value={dato.c_Localidad}>{dato.Nombre || dato.Localidad}</option>
                                                        );
                                                    }))}
                                                </select>
                                            }
                                        </div>
                                        {/* CÓDIGO POSTAL */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                    <span className="d-none d-xl-inline">Código Postal</span>
                                                    <span className="d-inline d-xl-none">C. Postal</span>
                                                </span>
                                            </div>
                                            <input type="text" className="form-control"
                                                disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                maxLength={5}
                                                onKeyPress={(eve) => {
                                                    if (eve.key === 'Enter' && ComercioExterior.Receptor_Pais !== 'USA') {
                                                        this.getCodigoPostalSAT_Receptor(ComercioExterior.Receptor_CodigoPostal);
                                                    }
                                                }}
                                                value={ComercioExterior.Receptor_CodigoPostal !== undefined ? ComercioExterior.Receptor_CodigoPostal : ""}
                                                onChange={(event) => this.changeFieldModel_Receptor(newOrderModel, "Receptor_CodigoPostal", event.target.value)}
                                                id="txtCodigoPostal" />
                                            {ComercioExterior.Receptor_Pais === 'MEX' && <button type="button" class="input-group-text"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                onClick={() => { this.getCodigoPostalSAT_Receptor(ComercioExterior.Receptor_CodigoPostal) }}>
                                                <i class="fas fa-search-location fa-lg" />
                                            </button>}
                                        </div>
                                        {/* NÚMERO EXTERIOR */}
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                    <span className="d-none d-xl-inline">Número Exterior</span>
                                                    <span className="d-inline d-xl-none">No. Ext</span>
                                                </span>
                                            </div>
                                            <input type="number" className="form-control"
                                                disabled={action === 2 && !editMode ? true : newOrderModel.isComercioExterior !== "Y" ? true : false}
                                                maxLength={10}
                                                value={ComercioExterior.Receptor_NumeroExterior ? ComercioExterior.Receptor_NumeroExterior : ""}
                                                onChange={(event) => this.changeFieldModel_Receptor(newOrderModel, "Receptor_NumeroExterior", event.target.value)}
                                                id="txtNumExterior" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {newOrderModel.isComercioExterior === "Y" &&
                            <div style={{ paddingTop: 10 }}>
                                <div className="table-responsive" style={{ height: 200, maxHeight: 200, overflow: 'auto', fontSize: "13px" }}>
                                    <table className="display" style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                                        <thead className="table-header-yellow" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                            <tr>
                                                <th>#</th>
                                                <th className='text-center'>NoIdentificacion</th>
                                                {/* <th className='text-center'>FraccionArancelaria</th> */}
                                                {/* <th className='text-center'>CantidadAduana</th> */}
                                                <th className='text-center'>UnidadAduana</th>
                                                {/* <th className='text-center'>ValorUnitarioAduana</th> */}
                                                {/* <th className='text-center'>ValorDolares</th> */}
                                                {/* <th className='text-center'>Marca</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!!ComercioExterior.Mercancias &&
                                                ComercioExterior.Mercancias.map((mercancia, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            {/* NoIdentificacion */}
                                                            <td className='text-center'>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={mercancia.NoIdentificacion ? mercancia.NoIdentificacion : ''}
                                                                    // disabled={action === 2 && !editMode ? true : false}
                                                                    disabled="true"
                                                                    onFocus={(event) => event.target.select()}
                                                                    onChange={event => this.Change_disposicionFiscal(event, index)}
                                                                />
                                                            </td>
                                                            {/* FraccionArancelaria */}
                                                            {/* <td style={{ minWidth: "150px" }}>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={mercancia.FraccionArancelaria ? mercancia.FraccionArancelaria : ''}
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onFocus={(event) => event.target.select()}
                                                            onChange={event => this.Change_norma(event, index)}
                                                        />
                                                    </td> */}
                                                            {/* CantidadAduana */}
                                                            {/* <td className='text-center' style={{ minWidth: "150px" }}>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={mercancia.CantidadAduana ? mercancia.CantidadAduana : ''}
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onFocus={(event) => event.target.select()}
                                                            onChange={event => this.Change_textoLeyenda(event, index)}
                                                        />
                                                    </td> */}
                                                            {/* UnidadAduana */}
                                                            <td className='text-center' style={{ minWidth: "150px" }}>
                                                                <select id="selLocalidades" class="form-control" value={mercancia.UnidadAduana ? mercancia.UnidadAduana : ""}
                                                                    onChange={event => this.Change_UnidadAduana(event, index)}
                                                                    disabled={(action === 2 && !editMode) ? true : false}
                                                                >
                                                                    <option value=''>Seleccione una opción</option>
                                                                    <option value='01'>01-KILO</option>
                                                                    <option value='02'>02-GRAMO</option>
                                                                    {/* <option value='03'>03-METRO LINEAL</option> */}
                                                                    {/* <option value='04'>04-METRO CUADRADO</option> */}
                                                                    {/* <option value='05'>05-METRO CUBICO</option> */}
                                                                    <option value='06'>06-PIEZA</option>
                                                                    {/* <option value='07'>07-CABEZA</option> */}
                                                                    <option value='08'>08-LITRO</option>
                                                                    {/* <option value='09'>09-PAR</option> */}
                                                                    {/* <option value='10'>10-KILOWATT</option> */}
                                                                    {/* <option value='11'>11-MILLAR</option> */}
                                                                    {/* <option value='12'>12-JUEGO</option> */}
                                                                    {/* <option value='13'>13-KILOWATT/HORA</option> */}
                                                                    <option value='14'>14-TONELADA</option>
                                                                    {/* <option value='15'>15-BARRIL</option> */}
                                                                    {/* <option value='16'>16-GRAMO NETO</option> */}
                                                                    {/* <option value='17'>17-DECENAS</option> */}
                                                                    {/* <option value='18'>18-CIENTOS</option> */}
                                                                    {/* <option value='19'>19-DOCENAS</option> */}
                                                                    {/* <option value='20'>20-CAJA</option> */}
                                                                    {/* <option value='21'>21-BOTELLA</option> */}
                                                                    {/* <option value='22'>22-CARAT</option> */}
                                                                    {/* <option value='99'>99-SERVICIO</option> */}
                                                                </select>
                                                            </td>
                                                            {/* ValorUnitarioAduana */}
                                                            {/* <td className='text-center' style={{ minWidth: "150px" }}>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={mercancia.ValorUnitarioAduana ? mercancia.ValorUnitarioAduana : ''}
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onFocus={(event) => event.target.select()}
                                                            onChange={event => this.Change_textoLeyenda(event, index)}
                                                        />
                                                    </td> */}
                                                            {/* ValorDolares */}
                                                            {/* <td className='text-center' style={{ minWidth: "150px" }}>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={mercancia.ValorDolares ? mercancia.ValorDolares : ''}
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onFocus={(event) => event.target.select()}
                                                            onChange={event => this.Change_textoLeyenda(event, index)}
                                                        />
                                                    </td> */}
                                                            {/* Marca */}
                                                            {/* <td className='text-center' style={{ minWidth: "150px" }}>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={mercancia.Marca ? mercancia.Marca : ''}
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onFocus={(event) => event.target.select()}
                                                            onChange={event => this.Change_Marca(event, index)}
                                                        />
                                                    </td> */}
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="tab-pane fade border border-top-0 rounded-bottom p-3" id="LeyendasFiscales">
                    </div>
                </div>
            </div>
        );
    }
}

export default ComercioExterior;